/**
 * ⭐⭐⭐ `R2-UI1` · **Plantillas: la LISTA «Plantillas para envíos» de un brazo.**
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⛔⛔⛔ RASTRO · 23/9/2026 · **ESTA PANTALLA MOSTRABA EL CATÁLOGO Y AHORA
 * MUESTRA LA LISTA. SON DOS COLECCIONES DISTINTAS.** `ADR-0082`: no se borra.
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Hasta `R1.1` acá se dibujaba `GET brazos/{brazo}/plantillas` —**el CATÁLOGO**,
 * o sea lo que la última sincronización trajo de Meta, entero—. `PRD_R2.md:805`
 * separa dos cosas que hasta hoy eran una:
 *
 *   ① **el CATÁLOGO** ... lo que Meta tiene. Se reemplaza ENTERO en cada
 *      sincronización. Nadie lo edita a mano.
 *   ② **la LISTA «Plantillas para envíos»** ... lo que el equipo armó eligiendo
 *      del catálogo. Entra por «Agregar plantilla», sale por «Quitar», y
 *      **ninguna sincronización le agrega ni le quita filas**. Es lo que se
 *      ofrece en Nuevo envío.
 *
 * ⇒ **esta tabla es la ②**, y de la ① sólo toma las columnas descriptivas
 * (Categoría, Variables, Estado en Meta, Botones), cruzadas por el borde.
 *
 * ⭐ **La regla más importante de `R2-F2` sale de la relación entre las dos**
 * (`PRD_R2.md:807`): si una plantilla de la lista deja de estar en el catálogo,
 * **la fila sigue en la lista y pasa a no poder enviarse**. No se borra sola y no
 * se sigue enviando en silencio. Ante la duda, el sistema no manda.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⛔⛔⛔ ① EL VEREDICTO LO DA EL BORDE Y ESTA PANTALLA NO LO RECALCULA
 * ════════════════════════════════════════════════════════════════════════════
 *
 * `B13`, `RT 9`, `PRD_R2.md:845`. Cada fila trae su `sendability` decidido sobre
 * el MISMO catálogo del que `canSend` saca el suyo en el motor de envío
 * (`R2-DS2`), y acá sólo se redacta (`./veredicto.ts` §`textoDelVeredicto`).
 *
 * ⚠️⚠️ **La tentación mide dos líneas y está a mano**: `fila.catalog` viaja al
 * lado de `fila.sendability`, así que `catalog?.approvalStatus === "APPROVED"`
 * compila y da lo mismo **hoy**. El día que no dé lo mismo, el operador lee
 * «Aprobada · Sí» acá y el envío sale «Fallido · La plantilla no se puede usar»,
 * y ningún examen del repo puede ver la diferencia porque cada lado está bien por
 * separado. El rastro entero está en `./veredicto.ts`.
 *
 * ⭐ **Y por eso «Estado en Meta» y «¿Se puede enviar?» no pueden contradecirse**
 * (`PRD_R2.md:845`): los dos salen de la misma fila del borde. Lo que sí pasa, y
 * hay que leer sin sorprenderse, es que las dos digan «No vino en la última
 * sincronización»: es una plantilla de la lista que el catálogo ya no tiene.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⛔⛔ ② ESTA PANTALLA NO LLAMA A META · (del encabezado anterior, intacto)
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Consume lo que `./borde-plantillas.ts` trajo. El botón manual **dispara la
 * misma operación que cualquier otro camino** (`borde.requestSync(brazo)`), no
 * uno paralelo y no una lectura disfrazada: el tercer camino —que el botón sólo
 * vuelva a LEER— se ve idéntico, no trae nada nuevo, y el operador concluye que
 * Meta no tiene la plantilla que sí tiene.
 *
 * ⚠️ **Y el `202` no promete un catálogo fresco.** Lo que se completó es el
 * PEDIDO. Ver el bloque ③.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⛔⛔ ③ «Sincronizando…» SALE DE `lastAttempt`, NO DE UN RELOJ · `B14`
 * ════════════════════════════════════════════════════════════════════════════
 *
 * `CA-46` y `CA-62`. El `POST` contesta `202` sin cuerpo: **no dice si Meta
 * contestó**. Lo que esta pantalla hace es **sondear el `GET` de la lista hasta
 * que `lastAttempt.lastAttemptAt` supere el instante del toque**, y recién ahí
 * decide, mirando `lastAttemptOutcome`.
 *
 * ⛔⛔ **Las dos salidas cómodas están descartadas, y las dos fallan en silencio:**
 *
 *   ⓐ **«mostrar el aviso si `lastSyncedAt` no cambió en N segundos»** — da falso
 *      ROJO cuando el doble de Meta tarda más que N (la sincronización salió bien
 *      y el operador lee que falló) y falso VERDE cuando Meta falló rápido y otra
 *      cosa movió el instante. Y sobre todo: **un intento fallido NO mueve
 *      `lastSyncedAt` a propósito** (`PRD_R2.md:855`), así que ese campo no puede
 *      distinguir «falló» de «todavía está corriendo». `lastAttempt` existe
 *      exactamente para eso.
 *   ⓑ **volver el `POST` síncrono** — viola `ADR-0248`: las credenciales WABA del
 *      brazo son de `apps/admin-web` y la sincronización corre contra Meta fuera
 *      del request, además de dejar la conexión colgada esperando a un tercero.
 *
 * ⚠️⚠️ **EL LITERAL `"ok"` DEL DESENLACE ES NO VERIFICADO, Y LA DIRECCIÓN DE
 * FALLA ESTÁ ELEGIDA.** `contracts/channel` §`TEMPLATE_SYNCS_LAST_ATTEMPT_OUTCOME_COLUMN`
 * dice, textual: *«El vocabulario concreto del valor lo fija el módulo; este
 * contrato fija el NOMBRE de la columna»*, y **medido el 23/9/2026 nadie lo
 * escribe todavía** —cero escrituras de `last_attempt_outcome` en `modules/` y en
 * `apps/`—. ⇒ acá se toma un solo literal como éxito y **todo lo demás se lee como
 * fallo**, que es la dirección de `ADR-0008` (la ausencia de dato no es una
 * aprobación): con el desenlace equivocado el operador ve el aviso de `CA-46`, que
 * lo manda a mirar la fecha y a reintentar, en vez de ver un verde que le esconde
 * un catálogo congelado. **Dueño del literal: quien escriba la columna
 * (`R2-JW1`), y hay que cruzarlo.**
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⛔ ④ LA PESTAÑA «Botones de respuestas automáticas» ~~ESTÁ Y NO NAVEGA~~ ·
 *      **NAVEGA, Y ESTA PANTALLA MONTA LAS DOS**
 * ════════════════════════════════════════════════════════════════════════════
 *
 * ⛔⛔⛔ **RASTRO · 23/9/2026, `R2-UI8` (`ADR-0348`). `ADR-0082`: no se borra.**
 * Este bloque decía, textual:
 *
 *   ~~«`CA-15` la quiere encendida; **esta etapa NO la enciende** y el caso queda
 *   `bloqueado: B2`. (…) el trabajo de `R2-UI8` acá es **sacar el `disabled` y
 *   poner el destino**, no armar una tabla.»~~
 *   ~~«**«Habilitarla ya que estoy» está descartado**: `src/respuestas-automaticas/`
 *   sigue en el árbol (lo borra `B24`) y quien la encienda tiene que decidir qué
 *   monta esa ruta.»~~
 *
 * **Las dos condiciones se cumplieron el mismo día:** `ui-marco` (`690ac148`,
 * `ADR-0362`) le dio a `App.tsx` sus dos `<Route>` hermanas, y esta etapa borró
 * `src/respuestas-automaticas/`. ⇒ el caso de QA deja de estar `bloqueado: B2`.
 *
 * ⚠️⚠️ **Y la predicción de ese párrafo era FALSA en su mitad más cara:** «sacar
 * el `disabled` y poner el destino» **no alcanzaba**. `R2-F3-CA-02` y `CA-03`
 * piden que en la pestaña ② la acción principal sea otra y que las tres acciones
 * de plantillas **no se vean** — o sea que esta pantalla no puede sólo navegar:
 * tiene que **decidir qué encabezado dibuja según la pestaña activa**, y ésa es
 * la costura que este archivo suma. La tabla de cinco columnas sí vive aparte
 * (`./botones/pantalla.tsx`).
 *
 * ════════════════════════════════════════════════════════════════════════════
 * ⚠️ ⑤ DE DÓNDE SALE EL BRAZO — la costura queda a la vista (del encabezado
 * anterior, y sigue valiendo entera)
 * ════════════════════════════════════════════════════════════════════════════
 *
 * El brazo lo da la RUTA (`ADR-0136` ②, `../brazo.ts`), y cuando la ruta no lo
 * declara **la pantalla falla cerrada y dice por qué**. No inventa un brazo por
 * defecto: `Arm = string` y los brazos son `[CONFIG]` por instancia, así que
 * cualquier default sería el nombre de una instancia disfrazado de constante — y
 * la lista del brazo equivocado, servida en silencio, es el daño que esto existe
 * para impedir.
 *
 * ⛔⛔ **Y «no se pudo preguntar» ≠ «nunca se sincronizó»** (`ADR-0244`, el
 * `guard` ⑥ de `AW46`, que `R2` **no** deroga): una respuesta que llegó VACÍA y
 * una que NO LLEGÓ confundidas dejan una lista vacía que además parece fresca,
 * *«que es la peor de las dos mitades»*. El estado del pedido sigue siendo un tipo
 * de TRES variantes y la tercera **no tiene instante y no lo puede fingir**.
 */

import { useCallback, useEffect, useMemo, useState } from "react"
import type { JSX } from "react"
import { useNavigate } from "react-router"
import { useBrazo } from "../brazo.ts"
import { rutaDeLaPantalla, SEGMENTOS } from "../rutas.ts"
import { formatearFecha } from "../conversaciones/formato.ts"
import { Paginado } from "../paginado.tsx"
import type { BordePlantillas, FilaParaEnvios, ListaParaEnvios } from "./borde-plantillas.ts"
import { PantallaBotones } from "./botones/pantalla.tsx"
import type { BordeBotones } from "./botones/borde-botones.ts"
import { PanelAgregar, plantillasQueSeOfrecen } from "./panel-agregar.tsx"
import { PopupQuitar } from "./popup-quitar.tsx"
import {
  botonParaMostrar,
  categoriaEnEspanol,
  estadoEnMeta,
  textoDelVeredicto,
  variablesParaMostrar,
} from "./veredicto.ts"
import { esBrazo, selloDelBrazo } from "../zonas.ts"
import type { Brazo } from "../zonas.ts"

/**
 * Las OCHO columnas de `PRD_R2.md:813-822`, en su orden y todas con dato.
 *
 * ⛔⭐ **RASTRO · 23/9/2026. «Categoría» y «Variables» ERAN MAQUETA** —dibujaban
 * «—» con `.maqueta-sin-datos`, `R1.1-F4-CA-57`/`CA-58`—. Dejan de serlo: el dato
 * lo trae `TemplateRecord.category` / `.variables`, que `R2-CCH1` agregó al
 * contrato. Las celdas de maqueta se van con su clase.
 *
 * ⛔ Van en la LISTA y no en un `if` del `<tbody>`: el encabezado y las celdas
 * salen de la misma fuente, así que no pueden quedar corridos.
 *
 * ⛔ **No hay ninguna columna «Disponible».** El estado crudo de Meta y nuestro
 * veredicto son DOS columnas a propósito (`ADR-0240`): la primera sirve para
 * reconciliar contra el WhatsApp Manager, la segunda es nuestra pregunta, y
 * explica **al lado** del literal, nunca en su lugar. Colapsarlas en un tilde
 * pierde los dos casos que esta pantalla existe para distinguir.
 */
const COLUMNAS = [
  "Plantilla",
  "Idioma",
  "Categoría",
  "Variables",
  "Estado en Meta",
  "¿Se puede enviar?",
  "Botones (en su orden)",
  "Acciones",
] as const

/**
 * ⭐ `PRD_R2.md:813` · **50 filas por página, y NO `config.pageSize`** (que vale
 * 10, `configuracion.ts:430`).
 *
 * El número es del criterio (`CA-63`) y no de la instancia: una instancia que
 * bajara `pageSize` a 10 partiría en dos una lista de quince y dejaría `CA-63`
 * rojo sin que nadie hubiera tocado esta pantalla.
 */
const FILAS_POR_PAGINA = 50

/**
 * Cada cuánto se vuelve a preguntar mientras una sincronización está corriendo.
 *
 * ⚠️ Es un valor PROPIO y no `config.refrescoMs` (5.000 ms): esto no es un
 * refresco de fondo, es la espera de una operación que el operador está mirando.
 * Cinco segundos de botón congelado se leen como una pantalla colgada.
 */
const SONDEO_MS = 500

/**
 * ⛔⛔⛔ RASTRO · 24/9/2026 · **EL SONDEO NO TENÍA TOPE, Y EN UAT kai NO TERMINÓ
 * NUNCA.** `ADR-0082`: el párrafo del efecto que decía «lo que espera es un HECHO,
 * no un plazo» queda tachado ahí mismo, con esto como su causa.
 *
 * Medido en UAT kai el 24/9/2026, en los dos brazos: tras cada clic en
 * «Sincronizar plantillas», `admin-web` registró `GET plantillas` +
 * `GET plantillas-para-envios` **cada ~0,6 s y sin fin (1.900+ pedidos)**, y el
 * botón quedó en «Sincronizando…» para siempre. La causa del servidor —no mandaba
 * `lastAttemptAt`/`lastAttemptOutcome`, así que el borde tiraba «forma que no se
 * entiende»— la cierra `apps/admin-web`. **La de esta pantalla es otra y es de
 * acá:** el `catch` y el «todavía no llegó» REPROGRAMABAN SIEMPRE. Un servidor roto
 * dejaba a la consola martillándolo y al operador sin salida.
 *
 * ⟦EL-SONDEO-TIENE-TOPE-DE-TIEMPO-Y-DE-ERRORES-SEGUIDOS⟧ Cualquiera de los dos que
 * se cumpla corta: sale de «Sincronizando…», muestra el aviso de `CA-46` y deja el
 * botón usable. **Ni el PRD ni el spec fijan un número** (`PRD_R2.md:826` sólo pide
 * que el botón «vuelva a su texto al terminar, salga bien o mal»;
 * `r2-ui1.md:66` deja el intervalo en «`REFRESCO_MS` o un valor propio»), así que:
 *
 *   · **`topeMs` = 30 s.** Sale de lo que el intento tarda en el peor caso NORMAL:
 *     `job-worker` recoge el disparo cada `SONDEAR_CADA_MS` = 1 s
 *     (`apps/job-worker/src/index.ts:36`) y espera a Meta hasta
 *     `TRANSPORT_TIMEOUT_MS` = 10 s por página (`apps/job-worker/.env.example:71`);
 *     con el catálogo en dos páginas (`CA-49`) y Meta «sin respuesta» (`CA-46`) eso
 *     es ≈ 21 s. Treinta deja margen. En UAT el intento se cerró en < 1 s.
 *   · **`erroresSeguidos` = 3.** Un corte de red aislado se perdona dos veces; un
 *     error de FORMA (`502` del borde) es determinista y no se arregla
 *     reintentando.
 *
 * ⚠️ **El costo, declarado:** si Meta tarda más que el tope y al final contesta
 * bien, el operador ve el aviso de fallo y la tabla vieja — el falso rojo ⓐ del
 * bloque ③. Se elige esa dirección (`ADR-0008`): el aviso lo manda a reintentar y
 * a mirar la fecha, que es inocuo; el sondeo infinito era un botón muerto.
 */
export type PlazosDelSondeo = {
  /** Espera antes de la SEGUNDA pregunta; la primera sale en el acto. */
  readonly primeroMs: number
  /** Techo del backoff. */
  readonly techoMs: number
  /** Cuánto se espera, en total desde el toque, a que aterrice el intento. */
  readonly topeMs: number
  /** Cuántos fallos SEGUIDOS del `GET` se toleran antes de rendirse. */
  readonly erroresSeguidos: number
}

/**
 * ⭐ **Backoff ×2 de 500 ms a 4 s**, y no 500 ms fijos (`[24/9/2026]`). El spec
 * no fija la frecuencia (`r2-ui1.md:66`). Con 500 ms fijos, los 30 s del tope son
 * 60 vueltas × 2 `GET` = 120 pedidos por clic; con el backoff son ≈ 11 vueltas. Lo
 * que se pierde es poco: el caso medido (< 1 s) se ve en la segunda o tercera
 * pregunta (0 s, 0,5 s, 1,5 s), y un intento de 10 s se ve a lo sumo 4 s tarde.
 */
const PLAZOS_DEL_SONDEO: PlazosDelSondeo = {
  primeroMs: SONDEO_MS,
  techoMs: 4_000,
  topeMs: 30_000,
  erroresSeguidos: 3,
}

/**
 * ⚠️⚠️ **EL LITERAL DEL DESENLACE, NO VERIFICADO.** Ver el bloque ③ del
 * encabezado: el vocabulario lo fija el módulo que escriba la columna y hoy no la
 * escribe nadie. Todo lo que no sea esto se lee como fallo, a propósito.
 */
const DESENLACE_BUENO = "ok"

/** El aviso de `CA-46`, palabra por palabra (`PRD_R2.md:1006`). */
const AVISO_DE_FALLO =
  "No se pudo sincronizar con Meta. Se muestra la información de la última sincronización. " +
  "Vuelve a intentarlo en unos minutos."

/**
 * ⭐⭐ El estado del PEDIDO. Ver el bloque ⑤: son tres variantes para que «no se
 * pudo preguntar» no se pueda escribir como «nunca se sincronizó».
 */
type EstadoDeLaLista =
  | { readonly caso: "pidiendo" }
  | { readonly caso: "traido"; readonly lista: ListaParaEnvios }
  | { readonly caso: "no-se-pudo-preguntar"; readonly mensaje: string }

const PIDIENDO: EstadoDeLaLista = { caso: "pidiendo" }

/** Lo que el `DELETE` / el `POST` de la lista dejó, para poder decirlo sin inventarlo. */
type EnLaFila = {
  readonly fila: FilaParaEnvios
  readonly enCurso: boolean
  readonly error: string | null
}

function mensajeDe(causa: unknown): string {
  return causa instanceof Error ? causa.message : String(causa)
}

/**
 * La fecha del instante, en `dd-mm-aaaa hh:mm` y en hora de Chile.
 *
 * ⚠️ **`formatearFecha` se importa de `../conversaciones/formato.ts` y no se
 * copia.** Vive ahí por herencia de R1.1 y lo mueve a `src/` el otro frente
 * (`R2-UI6`); copiarlo acá dejaría dos formateadores que divergen sobre la misma
 * zona horaria, que es el defecto que `R2-UI6` está yendo a cerrar.
 */
function fechaDeSincronizacion(instante: string): string {
  return formatearFecha(new Date(instante))
}

/**
 * ⭐⭐ `R2-UI8` · **Cuál de las dos pestañas está encendida.**
 *
 * ⛔ Es un valor con NOMBRE y no un `boolean`: un `esBotones?: boolean` deja
 * `{ esBotones: false }` y `{}` como el mismo estado, y el día que haya una
 * tercera pestaña el tipo no obliga a nadie a contestar qué muestra.
 */
export type PestanaDePlantillas = "envios" | "botones"

export function PantallaPlantillas({
  borde,
  panelAgregar = false,
  pestana = "envios",
  panelNuevoBoton = false,
  bordeBotones,
  plazosDelSondeo = PLAZOS_DEL_SONDEO,
}: {
  readonly borde: BordePlantillas
  /**
   * ⭐ Los plazos del sondeo, **inyectables sólo para que un examen no espere
   * 30 s de reloj** (`[24/9/2026]`). `App.tsx` no la pasa: en producción valen
   * los de `PLAZOS_DEL_SONDEO`.
   */
  readonly plazosDelSondeo?: PlazosDelSondeo
  /**
   * ⭐⭐ **La costura del panel «Agregar plantilla»: la enciende LA DIRECCIÓN.**
   *
   * `App.tsx` monta esta misma pantalla en DOS `<Route>` hermanas —
   * `SEGMENTOS.plantillas` sin la prop y `SEGMENTOS.agregarPlantilla` con ella—,
   * así que quién la pasa es el router y no un botón.
   *
   * ⛔ **Por eso es una prop y no un `useState` de esta pantalla.** `CA-19` pide
   * que al RECARGAR `…/plantillas/agregar` el panel siga abierto: un estado local
   * se pierde en la recarga, y `CA-17`/`CA-19` quedarían en rojo con cara de
   * verde. Ver `./panel-agregar.tsx` §①.
   *
   * ⚠️ **El default `false` es lo que deja a la ruta vieja intacta**: quien monte
   * `SEGMENTOS.plantillas` no tiene que saber que esto existe.
   */
  readonly panelAgregar?: boolean
  /**
   * ⭐⭐ `R2-UI8` · **Qué pestaña está activa, y lo decide LA DIRECCIÓN.**
   * `R2-F3-CA-01`.
   *
   * `App.tsx` monta esta misma pantalla en CUATRO `<Route>` hermanas:
   * `plantillas` y `plantillas/agregar` sin esta prop, y `plantillas/botones` y
   * `plantillas/botones/nueva` con `pestana="botones"`.
   *
   * ⛔ **Por eso es una prop y no un `useState` de esta pantalla**, por lo mismo
   * que `panelAgregar`: `CA-01` pide que la pestaña lleve a
   * `#/brazos/<brazo>/plantillas/botones` y que **esa pestaña quede activa**. Con
   * estado local, la pestaña se vería encendida y la dirección no cambiaría, o
   * peor: recargar `…/botones` mostraría la otra pestaña.
   */
  readonly pestana?: PestanaDePlantillas
  /** ⭐ `CA-14`/`CA-15` · el panel «Nueva respuesta automática», encendido por `…/botones/nueva`. */
  readonly panelNuevoBoton?: boolean
  /**
   * ⭐ El borde de la pestaña ②, **inyectable**. Ausente ⇒ la pestaña lo arma
   * contra la `admin-web` de `configuracion.json` (ver `./botones/pantalla.tsx`).
   *
   * ⛔ **Va por acá y no por `App.tsx`** para que esta etapa no le agregue un
   * parámetro a `pantallas()`: el marco es territorio de `ui-marco`, y el único
   * renglón que esta etapa cambió ahí es el `element=` de las dos `<Route>`.
   * ⚠️ Y existe porque un examen tiene que poder reemplazarlo por un doble
   * **montando las cuatro `<Route>` de verdad**: pisar `fetch` global mediría el
   * borde además de la pantalla, y un fallo del lector se leería como un fallo de
   * la tabla.
   */
  readonly bordeBotones?: BordeBotones
}): JSX.Element {
  const enBotones = pestana === "botones"
  const irA = useNavigate()
  const brazoDeLaRuta = useBrazo()
  /**
   * ⛔ `null` es «acá no se declaró ningún brazo» —o se declaró uno que no
   * existe— y no un default. La dirección de falla es cerrada.
   */
  const brazo: Brazo | null = esBrazo(brazoDeLaRuta) ? brazoDeLaRuta : null

  const [estado, setEstado] = useState<EstadoDeLaLista>(PIDIENDO)
  const [recarga, setRecarga] = useState(0)
  const [pagina, setPagina] = useState(1)

  /** El instante del toque, en ms. `null` = no hay ninguna sincronización en curso. */
  const [sincronizandoDesde, setSincronizandoDesde] = useState<number | null>(null)
  const [avisoDeFallo, setAvisoDeFallo] = useState(false)

  /*
   * ⛔⛔ **RASTRO · 23/9/2026, `R2-UI8`. ACÁ VIVÍA
   * `const [intentosEnLaPestana, setIntentosEnLaPestana] = useState(0)`.**
   *
   * Era el contador del control negativo de la pestaña deshabilitada: se
   * publicaba en `data-intentos` para poder afirmar que el navegador **no** emitía
   * el `click`. Con la pestaña ENCENDIDA (`R2-F3-CA-01`) el click se emite
   * siempre ⇒ el contador dejaría de descartar nada y daría verde también para
   * una pestaña que navegue al lugar equivocado. **Lo que lo reemplaza es afirmar
   * el DESENLACE** —la dirección y el `aria-selected`—, que es lo que los casos
   * reescritos miden. Ver el bloque de las pestañas más abajo.
   */

  const [quitando, setQuitando] = useState<EnLaFila | null>(null)
  const [agregando, setAgregando] = useState<{
    readonly enCurso: boolean
    readonly error: string | null
  }>({ enCurso: false, error: null })

  const recargar = useCallback(() => {
    setRecarga((valor) => valor + 1)
  }, [])

  /**
   * La lectura de la lista. Un solo brazo, el de la ruta.
   *
   * ⛔ **Sin brazo no se pide nada**: el brazo va en la ruta del borde, así que un
   * pedido sin brazo no existe en el cable.
   */
  useEffect(() => {
    /*
     * ⛔⛔ `R2-UI8` · **en la pestaña de botones NO se pide la lista de
     * plantillas.** Esta pantalla monta las DOS pestañas, pero cada una lee lo
     * suyo: un `GET …/plantillas-para-envios` + `GET …/plantillas` en la pestaña
     * de botones es tráfico que nadie dibuja, y —peor— deja a
     * `estado.caso === "no-se-pudo-preguntar"` pintando el cartel de error de la
     * OTRA colección sobre una tabla de botones que se leyó bien.
     */
    if (brazo === null || enBotones) return

    let cancelado = false
    setEstado(PIDIENDO)

    borde
      .listaParaEnvios(brazo)
      .then((lista) => {
        if (!cancelado) setEstado({ caso: "traido", lista })
      })
      .catch((causa: unknown) => {
        if (!cancelado) setEstado({ caso: "no-se-pudo-preguntar", mensaje: mensajeDe(causa) })
      })

    return () => {
      cancelado = true
    }
  }, [borde, brazo, enBotones, recarga])

  /**
   * ⭐⭐ **EL SONDEO DE `B14`.** Ver el bloque ③ del encabezado.
   *
   * Corre **sólo** mientras hay una sincronización en curso, y lo que espera es un
   * HECHO —`lastAttemptAt` posterior al toque—, no un plazo. Termina cuando ese
   * hecho llega, y entonces `lastAttemptOutcome` decide entre recargar la tabla y
   * mostrar el aviso.
   *
   * ⚠️ **Un `lastAttemptAt` que no se entiende como fecha NO corta el sondeo.**
   * `Number.isNaN` sobre el `getTime()` lo descarta y se sigue esperando: tratarlo
   * como «ya terminó» apagaría «Sincronizando…» sin que nada hubiera pasado, que
   * es el centinela que se abre temprano.
   *
   * ⛔⛔ **RASTRO · 24/9/2026.** ~~«lo que espera es un HECHO —`lastAttemptAt`
   * posterior al toque—, no un plazo»~~ · sin plazo, un servidor que nunca manda
   * el hecho deja el sondeo corriendo para siempre (UAT kai, 1.900+ pedidos). El
   * hecho sigue siendo lo ÚNICO que da el desenlace bueno; el plazo y los errores
   * seguidos sólo pueden dar el aviso. Ver `PLAZOS_DEL_SONDEO`.
   */
  const { primeroMs, techoMs, topeMs, erroresSeguidos } = plazosDelSondeo
  useEffect(() => {
    if (brazo === null || sincronizandoDesde === null) return

    const desde = sincronizandoDesde
    let cancelado = false
    let vuelta = 0
    let fallosSeguidos = 0

    /** Se rinde: el aviso de `CA-46` y el botón de vuelta. Los datos no se tocan. */
    const rendirse = (): void => {
      setSincronizandoDesde(null)
      setAvisoDeFallo(true)
    }

    const preguntar = async (): Promise<void> => {
      let lista: ListaParaEnvios
      try {
        lista = await borde.listaParaEnvios(brazo)
      } catch {
        /*
         * ⚠️ Un sondeo que falla **no es un intento fallido**: es este pedido el
         * que no llegó. Se reintenta, pero ~~se sigue preguntando~~ **sólo hasta
         * `erroresSeguidos`** `[24/9/2026]`: un error de forma no se arregla
         * reintentando, y martillar al servidor tampoco lo arregla.
         */
        if (cancelado) return
        fallosSeguidos = fallosSeguidos + 1
        if (fallosSeguidos >= erroresSeguidos) rendirse()
        else agendar()
        return
      }
      if (cancelado) return
      fallosSeguidos = 0

      const at = lista.lastAttempt.lastAttemptAt
      const cuando = at === null ? Number.NaN : new Date(at).getTime()
      if (Number.isNaN(cuando) || cuando <= sincronizandoDesde) {
        agendar()
        return
      }

      setSincronizandoDesde(null)
      if (lista.lastAttempt.lastAttemptOutcome === DESENLACE_BUENO) {
        /* `'ok'` ⇒ la tabla se recarga con lo que la sincronización dejó. */
        setAvisoDeFallo(false)
        setEstado({ caso: "traido", lista })
      } else {
        /*
         * ⛔ Cualquier otro desenlace ⇒ el aviso de `CA-46` **y los datos
         * anteriores intactos**: «No se borra nada, no cambia ningún estado y
         * “Última sincronización” no se mueve» (`PRD_R2.md:855`). Por eso NO se
         * escribe `setEstado` en esta rama.
         */
        setAvisoDeFallo(true)
      }
    }

    let reloj: ReturnType<typeof setTimeout> | null = null
    function agendar(): void {
      if (cancelado) return
      const espera = Math.min(primeroMs * 2 ** vuelta, techoMs)
      vuelta = vuelta + 1
      /*
       * ⛔ El tope se mide desde el TOQUE. La última pregunta cae justo en el
       * tope (no antes: se le da al intento todo el plazo); la siguiente ya no sale.
       */
      const restante = desde + topeMs - Date.now()
      if (restante <= 0) {
        rendirse()
        return
      }
      reloj = setTimeout(() => void preguntar(), Math.min(espera, restante))
    }

    void preguntar()

    return () => {
      cancelado = true
      if (reloj !== null) clearTimeout(reloj)
    }
  }, [borde, brazo, sincronizandoDesde, primeroMs, techoMs, topeMs, erroresSeguidos])

  /**
   * ⭐⭐ El botón de sincronización manual. **PIDE una sincronización**; no lee.
   *
   * ⚠️ **No es una lectura barata**: consume cuota de la Graph API contra la
   * cuenta del cliente. Por eso vive en un `onClick` y no en un `useEffect`. El
   * throttling **no está declarado en ninguna parte del cable** y esta etapa no lo
   * resuelve; dueño: el operador con el TL, y el trabajo es `ADR-0006`.
   *
   * ⛔ **El instante se toma ANTES del `await`.** Tomado después, una respuesta
   * lenta del `202` dejaría el corte del sondeo por detrás de un intento que ya
   * había empezado, y el sondeo cortaría con el desenlace del intento ANTERIOR.
   */
  async function sincronizarAhora(unBrazo: string): Promise<void> {
    const desde = Date.now()
    setAvisoDeFallo(false)
    setSincronizandoDesde(desde)
    try {
      await borde.requestSync(unBrazo)
    } catch {
      /*
       * El `POST` ni siquiera se pudo hacer: no hay ningún intento que esperar, y
       * dejar el botón en «Sincronizando…» sería esperar a algo que no existe.
       */
      setSincronizandoDesde(null)
      setAvisoDeFallo(true)
    }
  }

  async function confirmarQuitar(): Promise<void> {
    if (brazo === null || quitando === null) return
    const { fila } = quitando
    setQuitando({ fila, enCurso: true, error: null })
    try {
      await borde.quitar(brazo, fila.name, fila.language)
      setQuitando(null)
      recargar()
    } catch (causa: unknown) {
      setQuitando({ fila, enCurso: false, error: mensajeDe(causa) })
    }
  }

  /**
   * ⭐ `CA-17` / `CA-30` · **las dos direcciones del panel, en un solo lugar.**
   *
   * ⛔ Se arman con `rutaDeLaPantalla(brazo, SEGMENTOS.…)` y **no con una plantilla
   * de cadena escrita acá**. `/brazos/${brazo}/plantillas/agregar` a mano compila
   * igual y se desincroniza en silencio el día que el marco renombre un segmento:
   * la pantalla mandaría a una dirección que `PANTALLAS_DEL_BRAZO` ya no tiene, y
   * el desenlace sería «Esta pantalla no existe» sin que nada se pusiera rojo.
   */
  const rutaDelPanel = brazo === null ? null : rutaDeLaPantalla(brazo, SEGMENTOS.agregarPlantilla)
  const rutaDeLaLista = brazo === null ? null : rutaDeLaPantalla(brazo, SEGMENTOS.plantillas)

  /**
   * ⭐⭐ `R2-UI8` · **Las DOS direcciones de la pestaña de botones**, armadas con
   * `rutaDeLaPantalla(brazo, SEGMENTOS.…)` y no con una plantilla de cadena
   * escrita acá — por lo mismo que las dos de arriba: `/brazos/${brazo}/plantillas/botones`
   * a mano compila igual y se desincroniza en silencio el día que el marco
   * renombre un segmento, y el desenlace sería «Esta pantalla no existe» sin que
   * nada se pusiera rojo.
   */
  const rutaDeLosBotones =
    brazo === null ? null : rutaDeLaPantalla(brazo, SEGMENTOS.botonesDePlantillas)
  const rutaDelBotonNuevo =
    brazo === null ? null : rutaDeLaPantalla(brazo, SEGMENTOS.nuevoBotonDePlantillas)

  /** `CA-30` · «Cancelar» y Escape vuelven a la lista **sin `POST`**. */
  function cerrarElPanel(): void {
    setAgregando({ enCurso: false, error: null })
    if (rutaDeLaLista !== null) irA(rutaDeLaLista)
  }

  async function confirmarAgregar(name: string, language: string): Promise<void> {
    if (brazo === null) return
    setAgregando({ enCurso: true, error: null })
    try {
      await borde.agregar(brazo, name, language)
      setAgregando({ enCurso: false, error: null })
      /*
       * ⭐ `CA-28` · éxito ⇒ **vuelve a la lista Y la recarga**. Las dos cosas: sin
       * el `recargar()`, la vuelta mostraría la tabla vieja —sin la fila recién
       * agregada— y el operador concluiría que no se agregó.
       */
      recargar()
      if (rutaDeLaLista !== null) irA(rutaDeLaLista)
    } catch (causa: unknown) {
      /* El rechazo (404/409) se dice EN el panel y no lo cierra. */
      setAgregando({ enCurso: false, error: mensajeDe(causa) })
    }
  }

  const lista = estado.caso === "traido" ? estado.lista : null
  const filas: readonly FilaParaEnvios[] = lista?.filas ?? []

  /**
   * ⛔ **El orden es el que devolvió el borde y esta pantalla no lo toca.**
   * `PRD_R2.md:813` pide «la agregada más recientemente arriba» y
   * `DispatchTemplateRow` **no tiene `addedAt`** (medido el 23/9/2026 sobre
   * `contracts/channel/index.ts:4831`). Ordenar acá por lo único que hay —el
   * nombre— sería un orden inventado que se ve igual de plausible y es OTRO.
   * Hueco declarado; dueño: el borde de `R2-AW1`, que es quien tiene la columna.
   */
  const visibles = useMemo(
    () => filas.slice((pagina - 1) * FILAS_POR_PAGINA, pagina * FILAS_POR_PAGINA),
    [filas, pagina],
  )

  const ofrecidas = useMemo(
    () => (lista === null ? [] : plantillasQueSeOfrecen(lista.catalogoDelBrazo, lista.filas)),
    [lista],
  )

  const sello = brazo === null ? null : selloDelBrazo(brazo)
  const sincronizando = sincronizandoDesde !== null

  return (
    <section className="plantillas">
      <header className="plantillas__encabezado">
        <h1>Plantillas</h1>
        {/*
          ⭐⭐ `CA-17` · **«Agregar plantilla» NAVEGA, y la dirección es la que
          sobrevive a la recarga.**

          ⛔⛔ **RASTRO · 23/9/2026.** Hasta `R1.1` este botón era MAQUETA:
          `<button disabled>` sin `onClick`, porque `R1.1-F5-CA-62` lo listaba
          entre lo que «se ve con el diseño nuevo y no funciona» y
          `R1.1-F2-CA-104` pedía que su dirección diera «Esta pantalla no existe».
          **`R2-F2` construye el panel y deroga los dos.**

          ⛔ **Navega y NO abre un estado local**, que era la salida cómoda que el
          `guard` de la etapa nombra: con `useState`, `CA-17` (la DIRECCIÓN) y
          `CA-19` (que sobreviva la recarga) quedarían en rojo **con cara de
          verde** — el panel andaría y recargar lo cerraría.

          ⚠️ **Sin brazo no navega a ninguna parte**: la dirección del panel cuelga
          del brazo, y con la ruta sin declararlo no hay a dónde ir. Es la misma
          falla cerrada del bloque ⑤ del encabezado, y por eso el `disabled` de
          este botón ahora depende del brazo y no es una constante.
        */}
        {/*
          ⭐⭐⭐ `R2-UI8` · `CA-02`/`CA-03` · **LA ACCIÓN PRINCIPAL DEPENDE DE LA
          PESTAÑA, Y ES UNA SOLA.**

          `PRD_R2.md:1087`: en la pestaña de botones *«la acción principal
          “Nueva respuesta automática”. En esta pestaña **no se ven** “Última
          sincronización”, “Sincronizar plantillas” ni “Agregar plantilla”»*.

          ⛔ **No se muestran deshabilitados: NO SE VEN.** `CA-03` es textual —«no
          se ven»— y un botón gris sigue estando en el DOM y en el recorrido de
          teclado. Además la regla del sistema visual (`PRD_R1.1.md:796`) es *«como
          máximo una acción principal HABILITADA por pantalla»*: con los dos
          portadores puestos habría dos fondos de color compitiendo.

          ⇒ es un ternario sobre el MISMO renglón y no dos bloques condicionales
          sueltos: así no hay ninguna forma de que las dos acciones principales
          existan a la vez.
        */}
        {enBotones ? (
          <button
            type="button"
            className="boton boton--primario"
            disabled={rutaDelBotonNuevo === null}
            onClick={() => {
              if (rutaDelBotonNuevo !== null) irA(rutaDelBotonNuevo)
            }}
          >
            Nueva respuesta automática
          </button>
        ) : (
          <button
            type="button"
            className="boton boton--primario"
            disabled={rutaDelPanel === null}
            onClick={() => {
              if (rutaDelPanel !== null) irA(rutaDelPanel)
            }}
          >
            Agregar plantilla
          </button>
        )}
      </header>

      {/*
        ⛔⛔⛔ **RASTRO · 23/9/2026, `R2-UI8`. LAS DOS PESTAÑAS NAVEGAN.**
        `ADR-0082`: no se borra lo que había, se dice qué lo derogó.

        Hasta hoy la segunda era **`<button disabled>` con un contador
        `data-intentos`**, y el bloque ④ del encabezado explicaba por qué: la ruta
        existía a medias y `R2-UI1` no podía decidir qué montaba. **`ADR-0362`
        cerró la ruta (`ui-marco`, `690ac148`) y esta etapa monta la pantalla** ⇒
        `R1.1-F5-CA-64`/`CA-65` (*«tiene `disabled`»*, *«tocarla no mueve nada»*)
        quedan **derogados por `R2-F2-CA-15` y `R2-F3-CA-01`**, y sus casos se
        REESCRIBIERON —no se borraron— en `pruebas/r11-plantillas.test.tsx` y
        `pruebas/r2-plantillas.test.tsx` (`A11`).

        ⛔ **Y con el `disabled` se va `data-intentos`, que no es un descuido:** ese
        contador existía para medir que el navegador **no emitía** el `click`. Con
        la pestaña encendida el click sí se emite siempre, así que el atributo
        pasaría a dar verde a cualquier implementación —incluida una que navegue
        al lugar equivocado—. Lo que hoy hay que medir es **el DESENLACE**: la
        dirección y qué pestaña queda activa. Dejarlo sería un instrumento que
        contesta otra pregunta.

        ⛔ Siguen siendo `<button>` y no `<a>`: `role="tab"` + `aria-selected` es
        el patrón que `plantillas__pestana` ya estila, y la navegación va por el
        router (`irA`), no por una recarga de documento.
      */}
      <div className="plantillas__pestanas" role="tablist" aria-label="Vistas de plantillas">
        <button
          type="button"
          role="tab"
          aria-selected={enBotones ? "false" : "true"}
          className={
            enBotones ? "plantillas__pestana" : "plantillas__pestana plantillas__pestana--activa"
          }
          onClick={() => {
            if (enBotones && rutaDeLaLista !== null) irA(rutaDeLaLista)
          }}
        >
          Plantillas para envíos
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={enBotones ? "true" : "false"}
          className={
            enBotones ? "plantillas__pestana plantillas__pestana--activa" : "plantillas__pestana"
          }
          /*
           * ⚠️ Sin brazo no navega a ninguna parte: la dirección de la pestaña
           * cuelga del brazo, y con la ruta sin declararlo no hay a dónde ir. Es
           * la misma falla cerrada del bloque ⑤ del encabezado.
           */
          disabled={rutaDeLosBotones === null}
          onClick={() => {
            if (!enBotones && rutaDeLosBotones !== null) irA(rutaDeLosBotones)
          }}
        >
          Botones de respuestas automáticas
        </button>
      </div>

      {/*
        ⭐⭐ `R2-UI8` · **LA PESTAÑA DE BOTONES ES OTRA PANTALLA, Y EL CORTE ES ACÁ.**

        Todo lo de abajo —la nota de la lista, el bloque de sincronización, la
        tabla de ocho columnas, su paginado, el panel «Agregar plantilla» y el
        popup «Quitar»— es de la pestaña ①. `CA-03` pide que en la ② **no se vea**
        nada de eso, y la forma de cumplirlo que no se puede escribir mal es que
        no se MONTE.

        ⛔ **La alternativa —esconder cada bloque con su propio `&&`— está
        descartada**: son ocho sitios, y el que alguien olvide se ve exactamente
        igual hasta que el operador abre la pestaña. Un solo corte no tiene esa
        falla.
      */}
      {/*
        ⚠️ **El borde se pasa con un spread CONDICIONAL y no como
        `bordeBotones={bordeBotones}`**, y no es estilo: con
        `exactOptionalPropertyTypes: true` —que este `tsconfig` declara— pasar
        `undefined` EXPLÍCITAMENTE no es lo mismo que no pasar la prop, y el
        segundo es el único que deja actuar al default de `PantallaBotones`.
        Escrito de la forma corta es `error TS2375`.
      */}
      {enBotones && (
        <PantallaBotones
          panelNuevo={panelNuevoBoton}
          {...(bordeBotones === undefined ? {} : { bordeBotones })}
        />
      )}

      {!enBotones && (
        <>
      {/*
        ⭐ `CA-14` · la nota que explica qué es esta lista. Es la única frase de la
        pantalla que dice la relación entre las DOS colecciones, y sin ella
        «Plantillas» se lee como «lo que Meta tiene».
      */}
      <p className="plantillas__nota">
        Solo las plantillas de esta lista aparecen en Nuevo envío. Se agregan desde lo que trajo la
        última sincronización con Meta.
      </p>

      {brazo === null && (
        <p className="plantillas__vacio" role="status">
          Esta pantalla muestra las plantillas <strong>de un brazo</strong>, y ni la ruta actual ni
          la configuración de esta instancia declaran ninguno. Ábrela desde el menú del brazo.
        </p>
      )}

      {brazo !== null && (
        <div className="plantillas__sincronizacion">
          {/*
            ⭐⭐ EL PRIMER EJE, DICHO UNA VEZ Y APARTE DEL ESTADO DE CADA FILA.
            Sin esto, «esta plantilla no está» y «esta plantilla todavía no se
            trajo» se ven igual, y el operador la va a buscar al WhatsApp Manager,
            donde está.

            ⚠️ Lo que afirma es «cuándo se trajo la lista», NO «esto es lo que Meta
            tiene ahora»: la segunda no la puede afirmar nadie sin llamar a Meta.
          */}
          {estado.caso === "pidiendo" && (
            <span className="plantillas__estado-carga" role="status">
              Trayendo las plantillas…
            </span>
          )}

          {/*
            ⭐ `CA-61` / regla 14 · **«Todavía no se sincronizó» EN LUGAR de la
            fecha**, no además de ella. Un «Última sincronización: —» se lee como
            un dato que falta; esto es un hecho.
          */}
          {lista !== null && lista.lastSyncedAt === null && (
            <span className="plantillas__instante" role="status">
              Todavía no se sincronizó
            </span>
          )}

          {lista !== null && lista.lastSyncedAt !== null && (
            <span className="plantillas__instante" role="status">
              Última sincronización {fechaDeSincronizacion(lista.lastSyncedAt)}
            </span>
          )}

          <button
            type="button"
            /*
             * ⛔⛔ **RASTRO · 23/9/2026 · ~~`className="boton boton--primario"`~~ —
             * EL PORTADOR DE LA ACCIÓN PRINCIPAL SE MUDÓ A «Agregar plantilla».**
             *
             * `R1.1-F5-CA-75` (`PRD_R1.1.md:894`) decía textual: *«En Plantillas la
             * acción principal es sincronizar: el único botón habilitado con fondo
             * de color es “Sincronizar plantillas”; “Agregar plantilla”,
             * deshabilitado, no cuenta»*. **La segunda cláusula dice por qué ya no
             * vale: «deshabilitado».** Era la principal porque era la única que
             * hacía algo.
             *
             * ⭐ **Lo deroga `PRD_R2.md:824`**, que nombra al otro con todas las
             * letras: *«y **el botón principal «Agregar plantilla»**, que lleva a
             * `#/brazos/<brazo>/plantillas/agregar`»*. Y tiene sentido de producto:
             * sincronizar es mantenimiento —se toca cuando algo no cuadra—, mientras
             * que armar la lista es para lo que se entra a esta pantalla.
             *
             * ⛔ **Y NO pueden ser las dos.** La regla del sistema visual
             * (`PRD_R1.1.md:796`) es *«como máximo una acción principal HABILITADA
             * por pantalla»*, y ahora las dos están habilitadas. Dejarle el portador
             * a éste «porque ya lo tenía» daría dos fondos de color compitiendo, que
             * es precisamente lo que esa regla existe para impedir.
             */
            className="boton"
            onClick={() => void sincronizarAhora(brazo)}
            /*
             * ⭐ `CA-62` · deshabilitado **y con otro texto** mientras corre: «así
             * un doble toque no manda dos pedidos a Meta» (`PRD_R2.md:824`). Los
             * dos hacen falta — el atributo impide el segundo toque y el texto
             * dice por qué el botón no responde.
             */
            disabled={sincronizando}
            aria-busy={sincronizando}
          >
            {sincronizando ? "Sincronizando…" : "Sincronizar plantillas"}
          </button>

          {estado.caso === "no-se-pudo-preguntar" && (
            <p className="plantillas__error" role="alert">
              No se pudieron leer las plantillas de este brazo. {estado.mensaje} Eso{" "}
              <strong>no es «nunca se sincronizó»</strong>: es que esta vez no se pudo preguntar, y
              de lo que Meta tenga aquí no se sabe nada.
            </p>
          )}

          {/*
            ⭐ `CA-46` · el aviso del intento fallido. Sale de `lastAttempt` (ver
            el bloque ③) y **no toca los datos**: la fecha sigue siendo la vieja y
            las filas siguen como estaban, que es justamente lo que deja ver que el
            catálogo se congeló.
          */}
          {avisoDeFallo && (
            <p className="plantillas__error" role="alert">
              {AVISO_DE_FALLO}
            </p>
          )}
        </div>
      )}

      {/*
        ⭐ `PRD_R2.md:828` · la lista vacía es un RESULTADO, no un fallo de
        lectura, y es distinta de «no se pudo preguntar» (que lo dice el aviso de
        arriba) y de «nunca se sincronizó» (que lo dice el instante).

        ⛔ Por eso se exige `estado.caso === "traido"`: con el pedido en curso o
        caído, cero filas no significa «no hay plantillas», y decirlo sería la
        mentira que `ADR-0244` ⓑ existe para impedir.
      */}
      {lista !== null && filas.length === 0 && (
        <p className="plantillas__vacio">
          Todavía no hay plantillas para envíos en {sello ?? "este brazo"}. Usa «Agregar plantilla».
        </p>
      )}

      {filas.length > 0 && (
        <>
          <div className="tabla-rodante">
            <table className="plantillas__tabla">
              {/*
                ⭐ `PRD_R2.md:813` · la leyenda EMPIEZA nombrando la zona, y acá
                pesa más que en otras pantallas: los dos brazos son **dos WABA con
                el mismo juego de plantillas**, así que `bienvenida_puro` y
                `bienvenida_hibrido` se ven casi iguales.

                ⛔ Y dice «Plantillas para envíos», no «Catálogo»: son las DOS
                colecciones del rastro del encabezado, y ésta es la ②.
              */}
              <caption className="plantillas__caption">
                {sello === null
                  ? "Plantillas para envíos."
                  : `Plantillas para envíos de ${sello}.`}
              </caption>
              <thead>
                <tr>
                  {COLUMNAS.map((columna) => (
                    <th key={columna} scope="col">
                      {columna}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {visibles.map((fila) => {
                  /*
                   * ⛔⛔ EL VEREDICTO LLEGA DECIDIDO. Ver el bloque ①: acá sólo se
                   * elige el TEXTO, mirando el `kind` que trajo la fila y el
                   * `lastSyncedAt` del brazo para separar los dos «No» que
                   * comparten `kind`.
                   */
                  const veredicto = textoDelVeredicto(
                    fila.sendability,
                    lista?.lastSyncedAt ?? null,
                  )
                  const variables = variablesParaMostrar(fila.catalog)
                  const botones = fila.catalog?.buttons ?? []
                  return (
                    <tr key={`${fila.name}·${fila.language}`}>
                      <td>{fila.name}</td>
                      <td>{fila.language}</td>
                      <td>{categoriaEnEspanol(fila.catalog?.category ?? null)}</td>
                      <td>
                        {variables.length === 0 ? (
                          "Sin variables"
                        ) : (
                          /*
                           * ⭐ «una por línea» (`PRD_R2.md:817`). Una lista y no un
                           * `join(", ")`: el orden es el del relleno posicional de
                           * Meta, y en una línea sola `{{1}}, {{2}}` se lee como un
                           * texto y no como dos cosas contables.
                           */
                          <ul className="plantillas__variables">
                            {variables.map((variable) => (
                              <li key={variable}>{variable}</li>
                            ))}
                          </ul>
                        )}
                      </td>
                      <td>{estadoEnMeta(fila.catalog)}</td>
                      <td>
                        <span className="plantillas__veredicto">
                          {veredicto.respuesta}
                          {/*
                            ⭐ El motivo va DEBAJO y en su propio elemento
                            (`PRD_R2.md:818`): pegado al «No» se leería como parte
                            de la respuesta, y con veinte filas lo que se compara
                            de un vistazo es la primera palabra.
                          */}
                          {veredicto.motivo !== null && (
                            <small className="plantillas__motivo">{veredicto.motivo}</small>
                          )}
                        </span>
                      </td>
                      <td>
                        {botones.length === 0 ? (
                          <span className="plantillas__sin-botones">
                            Esta plantilla no trajo botones.
                          </span>
                        ) : (
                          <ol className="plantillas__botones">
                            {/*
                              ⛔ Se recorren con `.map()` sobre el arreglo del
                              catálogo y **nada más**: no se ordenan, no se agrupan
                              por tipo y no se deduplican. Meta identifica un botón
                              por su POSICIÓN ⇒ si el orden que el operador VE no es
                              el que EXISTE, lo que configure mirando esta pantalla
                              apunta a OTRO botón, el sistema hace exactamente lo
                              que se le configuró, y ningún examen del repo puede
                              ver la diferencia.
                            */}
                            {botones.map((boton) => (
                              <li key={boton.position} className="plantillas__boton">
                                {botonParaMostrar(boton)}
                              </li>
                            ))}
                          </ol>
                        )}
                      </td>
                      {/*
                        ⭐ `CA-13` · **«Quitar» y ninguna otra acción.** No hay
                        «Editar» ni «Ver en Meta»: las plantillas se crean y se
                        editan en el WhatsApp Manager del brazo, y este producto no
                        las escribe.

                        ⚠️ Variante CALLADA de `--peligro`: abrir una confirmación
                        no es destructivo. El rojo sólido es del «Sí, quitar
                        plantilla» de adentro del popup.
                      */}
                      <td>
                        <button
                          type="button"
                          className="boton boton--chico boton--peligro"
                          onClick={() => setQuitando({ fila, enCurso: false, error: null })}
                        >
                          Quitar
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          {/*
            ⭐ `CA-63` / regla 16 · «Anterior · Página N de M · Siguiente», con la
            primitiva compartida (`src/paginado.tsx`) y no una barra propia.

            ⚠️ `total` es `filas.length` y **acá eso es correcto**, al revés que en
            las otras siete pantallas: el borde de la lista devuelve TODAS las filas
            del brazo en un pedido —no hay paginado en el cable— así que el total
            que la pantalla tiene ES el de la base. El día que el borde pagine, esto
            miente y hay que mover el corte al servidor.
          */}
          <Paginado
            etiqueta="plantillas para envíos"
            pagina={pagina}
            total={filas.length}
            tamanoDePagina={FILAS_POR_PAGINA}
            onPagina={setPagina}
            unidad={{ singular: "plantilla", plural: "plantillas" }}
          />
        </>
      )}

      {/*
        ⭐ `CA-18`/`CA-19` · el panel lo dibuja **la DIRECCIÓN**, por la prop que
        `App.tsx` le pasa desde su `<Route>` hermana. Que sea la URL y no un estado
        es lo que hace que sobreviva a la recarga.
      */}
      {panelAgregar && sello !== null && (
        <PanelAgregar
          sello={sello}
          ofrecidas={ofrecidas}
          enCurso={agregando.enCurso}
          error={agregando.error}
          onCancelar={cerrarElPanel}
          onAgregar={(name, language) => void confirmarAgregar(name, language)}
        />
      )}

      {quitando !== null && sello !== null && (
        <PopupQuitar
          nombre={quitando.fila.name}
          sello={sello}
          enCurso={quitando.enCurso}
          error={quitando.error}
          onCancelar={() => setQuitando(null)}
          onConfirmar={() => void confirmarQuitar()}
        />
      )}
        </>
      )}
    </section>
  )
}
